<template>
  <div v-if="false">
    <el-table :data="data" style="width: 100%">
      <el-table-column prop="prop" label="label" width="width">
      </el-table-column>
    </el-table>
    <el-button
      v-popover="popoverRef"
      v-click-outside="onClickOutside"
      @click="show"
      :disabled="testValue === ''"
      >Click me</el-button
    >
    <el-popover
      ref="popoverRef"
      trigger="click"
      title="With title"
      virtual-triggering
      persistent
    >
      <span> Some content </span>
      <el-input v-model="testValue" placeholder=""></el-input>
      <el-button type="primary" @click="test">close</el-button>
    </el-popover>

    <div>
      <el-input></el-input>
    </div>

    <div>
      <democomponent />
    </div>

    <div>
      State
      <DemoState />
    </div>
    Key:{{ key }}
    <el-button type="primary" @click="RedirectClick">Redirect</el-button>
    <div>
      Transition :
      <TransitionTest />
    </div>
    <div>Validator:</div>
    <Validator></Validator>

    <div>导出</div>
    <ExportExcel />

    <el-button type="primary" @click="onFocus">获取焦点</el-button>
    <input type="text" id="demo" />

    <DayJsVue />

    <div>
      父组件
      <div>
        <el-button type="primary" @click="changeTest">加天数</el-button>
      </div>
      父组件值:
      {{ data }}
      <el-table :data="data" style="width: 100%">
        <el-table-column prop="dates" label="date picker">
          <template #default="scope">
            <BindModel v-model="scope.row.dates" />
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div>
      <button @click="test">Show Discard</button>
      <div>Result:{{ actionResult }}</div>
    </div>

    <button @click="isshow = !isshow">Toggle</button>
    <Transition>
      <p v-if="isshow" style="color: black">hello</p>
    </Transition>

    <base-input></base-input>
    <div>Please Select</div>
    <base-input @click="DemoFocus">
      <div
        style="
          width: 300px;
          border: 1px solid black;
          min-height: 32px;
          background-color: #fff;
        "
      >
        <el-tag
          v-for="(tag, index) in dates"
          :key="'tag' + index"
          class="mx-1"
          closable
          type="info"
          effect="dark"
        >
          {{ tag }}
        </el-tag>
      </div>
      <div style="position: absolute; top: 16px; left: 149px">
        <el-date-picker
          v-model="date"
          type="date"
          placeholder="Pick a day"
          id="demo-picker"
          :prefix-icon="icon"
          ref="dateRef"
          :shortcuts="shortcuts"
          value-format="DD/MM/YYYY"
          popper-class="demo"
        />
      </div>
    </base-input>

    <date-picker v-model="dates" :shortcuts="shortcuts">
      <template #title>
        <div>Please Select</div>
      </template>
      <template #footer>
        <div class="text-right">
          <base-button type="primary">Confirm</base-button>
          <base-button type="Cancel">Cancel</base-button>
        </div>
      </template>
    </date-picker>
    <el-select
      v-model="value"
      filterable
      allow-create
      default-first-option
      :reserve-keyword="false"
      placeholder="Choose tags for your article"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      />
    </el-select>
  </div>
  <div style="background-color: #fff"><DemoFullCalendar /></div>
</template>

<script setup>
import { ref, unref, onMounted, watch } from 'vue';
import { ClickOutside as vClickOutside } from 'element-plus';
import democomponent from '@/views/demo/CurrencyComponent';
import DemoState from './DemoState.vue';
import { useRoute } from 'vue-router';
//import router from "../../router";
import TransitionTest from './TransitionTest.vue';
import Validator from './Validator.vue';
import BindModel from '@/views/demo/BindModel';
import ExportExcel from '@/views/demo/ExportExcel';
import DayJsVue from './DayJs.vue';
import discardMessage from '../../components/discardMessage/discardMessage';
import baseInput from '@/components/newUI/Inputs/BaseInput';
// import DiscardMessageVue from './DiscardMessage.vue';
import DatePicker from '@/components/DatePicker';
import baseButton from '@/components/newUI/BaseButton';
import DemoFullCalendar from './DemoFullCalendar.vue';

const route = useRoute();

const testValue = ref('');
const actionResult = ref('');
const isshow = ref(false);
const dates = ref([]);
const date = ref();
const demo = ref();
const dateRef = ref();
const value = ref();
const options = ref([
  {
    value: '1',
    label: '1',
  },
  {
    value: '2',
    label: '2',
  },
  {
    value: '3',
    label: '3',
  },
]);

console.log('dateRef', dateRef);

const DemoFocus = () => {
  console.log(unref(dateRef));
  unref(dateRef)?.focus();
};

const shortcuts = [
  {
    text: 'To Be Confirmed',
    value: () => {
      dates.value.push('To Be Confirmed');
      return '';
    },
  },
];

//const testDateValue = ref(["2022-09-19", "2022-10-19"]);

const popoverRef = ref();
const onClickOutside = () => {
  unref(popoverRef).popperRef?.delayHide?.();
};

const key = route.query.key;

onMounted(() => {
  console.log('进入demo');
});

console.log('popoverRef', popoverRef);
const test = () => {
  //popoverRef.value.hide();
  discardMessage({
    title: '',
    message: 'this is Discard Message',
    confirmButtonText: 'Save',
    cancelButtonText: 'Discard',
    closeButtonText: 'Close',
  })
    .then((action) => {
      actionResult.value = action;
    })
    .catch((action) => {
      actionResult.value = action;
    });
};

const data = ref([
  {
    dates: ['2022-01-01', '2022-01-30'],
  },
]);

const show = () => {
  testValue.value = '1';
};

const changeTest = () => {
  var dayjs = require('dayjs');

  data.value.map((t) => {
    t.dates = [
      dayjs(t.dates[0]).add(1, 'day').format('YYYY-MM-DD'),
      dayjs(t.dates[1]).add(1, 'day').format('YYYY-MM-DD'),
    ];
  });
};
// const RedirectClick = () => {
//   router.push({
//     name: 'demo',
//     query: {
//       key: '22',
//     },
//   });
// };

// const RedirectClick = () => {
//   router.push({
//     name: 'demo',
//     query: {
//       key: '22',
//     },
//   });
// };

watch(
  () => date.value,
  (newVal, oldVal) => {
    if (newVal) {
      console.log(newVal);
      dates.value.push(newVal);
      date.value = '';
    }
  },
  {
    immediate: true,
  }
);
</script>
<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.el-input__wrapper > #demo-picker {
  height: 0px;
  background: none;
  width: 0px;
  padding: 0;
}
.el-input__wrapper:has(#demo-picker) {
  height: 0px;
  width: 0px;
  padding: 0;
}
.el-date-editor:has(#demo-picker) {
  height: 0px !important;
  width: 0px !important;
  padding: 0;
  border: 0;
}
.el-date-editor:has(#demo-picker) .el-input__prefix {
  display: none;
}
.demo .el-picker-panel__body-wrapper .el-picker-panel__sidebar {
  width: 100%;
  top: unset;
  margin-bottom: 10px;
}

.demo .el-picker-panel__body-wrapper .el-picker-panel__sidebar button {
  width: 130px;
  height: 40px;
  border-radius: 6px;
  background-color: #3182ce;
  color: #fff;
  text-align: center;
  margin: 0 auto;
}

.demo .el-picker-panel__body-wrapper .el-picker-panel__body {
  margin-left: 0px;
  margin-bottom: 45px;
}
</style>
